import { Route, Routes } from "react-router";
import { NotFound } from "../../app/pages/NotFound";
import { WILDCARD_ROUTE } from "../../common/constants";
import { Permission } from "../../common/security/enums";
import PageWithPermission from "../auth/components/PageWithPermission";
import { AdminUserCreateContainer } from "./containers/AdminUserCreateContainer";
import { AdminUserDetailContainer } from "./containers/AdminUserDetailContainer";
import { AdminUserListContainer } from "./containers/AdminUserListContainer";
import { UserCommissionsContainer } from "./containers/UserCommissionsContainer";
import { UserProfileContainer } from "./containers/UserProfileContainer";
import { ADMIN_USER_ROUTE_PATHS, CURRENT_USER_ROUTE_PATHS } from "./paths";

export const AdminUserRoutes = () => (
  <Routes>
    <Route
      index
      element={<PageWithPermission component={<AdminUserListContainer />} permissions={[Permission.ADMIN_USERS]} />}
    />

    <Route
      path={ADMIN_USER_ROUTE_PATHS.create.path}
      element={<PageWithPermission component={<AdminUserCreateContainer />} permissions={[Permission.ADMIN_USERS]} />}
    />

    <Route
      path={ADMIN_USER_ROUTE_PATHS.detail.path}
      element={<PageWithPermission component={<AdminUserDetailContainer />} permissions={[Permission.ADMIN_USERS]} />}
    />

    <Route path={WILDCARD_ROUTE} element={<NotFound />} />
  </Routes>
);

export const CurrentUserRoutes = () => (
  <Routes>
    <Route path={CURRENT_USER_ROUTE_PATHS.profile.path} element={<UserProfileContainer />} />

    <Route
      path={CURRENT_USER_ROUTE_PATHS.commissions.path}
      element={
        <PageWithPermission component={<UserCommissionsContainer />} permissions={[Permission.PROFILE_COMMISSIONS]} />
      }
    />

    <Route path={WILDCARD_ROUTE} element={<NotFound />} />
  </Routes>
);
